import script from "./edit-expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-expenses.vue?vue&type=script&setup=true&lang=js"

import "./edit-expenses.vue?vue&type=style&index=0&id=598237b0&lang=css"

const __exports__ = script;

export default __exports__